import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import { FadeReveal } from '../FadeReveal/index';
import { Icon } from '../Icon/index';
import { borderTypes, sizes, } from './constants';
import { errorMessageStyles, optionStyles, useErrorSpacingStyles, useIconContainerStyles, useInnerLabelStyles, useSelectContainerStyles, useSelectStyles, } from './styles';
const defaultProps = {
    borderType: borderTypes.full,
    disabled: false,
    error: '',
    hasErrorSpacing: false,
    id: '',
    label: null,
    onBlur: () => { },
    placeholder: 'Select One',
    required: false,
    size: sizes.medium,
    touched: false,
    value: '',
};
const Select = ({ ariaLabel, autoComplete, borderType = defaultProps.borderType, disabled = defaultProps.disabled, error = defaultProps.error, hasErrorSpacing = defaultProps.hasErrorSpacing, id = defaultProps.id, label, name, onBlur = defaultProps.onBlur, onChange, options, placeholder = defaultProps.placeholder, required = defaultProps.required, size = defaultProps.size, touched = defaultProps.touched, value = defaultProps.value, }) => {
    const inputID = useMemo(() => (id || name), [
        id,
        name,
    ]);
    const selectOptions = useMemo(() => (options
        .map(({ isDisabled, text, value: optionValue, }) => (_jsx("option", Object.assign({ "aria-selected": `${optionValue}` === `${value}`, css: optionStyles, disabled: isDisabled, value: optionValue }, { children: text }), optionValue)))), [
        options,
        value,
    ]);
    const iconContainerStyles = useIconContainerStyles({
        size,
    });
    const innerLabelStyles = useInnerLabelStyles({
        size,
    });
    const selectContainerStyles = useSelectContainerStyles({
        disabled,
        size,
    });
    const selectStyles = useSelectStyles({
        borderType,
        disabled,
        error,
        isDefaultFont: true,
        label,
        size,
        touched,
        value,
    });
    const errorSpacingStyles = useErrorSpacingStyles({
        size,
    });
    const wrapperStyles = useMemo(() => (css `
      ${hasErrorSpacing && errorSpacingStyles}
        /* If text alignment is changed in the parent, it will break the styles for Select. */
        text-align: left;
        width: 100%;
      `), [
        errorSpacingStyles,
        hasErrorSpacing,
    ]);
    const localAriaLabel = useMemo(() => (label
        ? undefined
        : ariaLabel), [
        ariaLabel,
        label,
    ]);
    return (_jsxs("div", Object.assign({ css: wrapperStyles }, { children: [_jsxs("div", Object.assign({ css: selectContainerStyles }, { children: [_jsxs("select", Object.assign({ "aria-label": localAriaLabel, autoComplete: autoComplete, css: selectStyles, disabled: disabled, id: inputID, name: name, onBlur: onBlur, onChange: onChange, placeholder: placeholder, required: required, value: value }, { children: [_jsx("option", Object.assign({ hidden: true, value: "" }, { children: placeholder })), selectOptions] })), label
                        && (_jsx("label", Object.assign({ css: innerLabelStyles, htmlFor: inputID }, { children: label }))), _jsx("div", Object.assign({ css: iconContainerStyles }, { children: _jsx(Icon, { size: "extraSmall", type: "arrow-down" }) }))] })), _jsx(FadeReveal, Object.assign({ in: !!touched && !!error, unmountOnExit: true }, { children: _jsx("div", Object.assign({ css: errorMessageStyles }, { children: _jsx("span", Object.assign({ role: "alert" }, { children: error })) })) }))] })));
};
const MemoizedSelect = memo(Select);
export { MemoizedSelect as Select };
// MC-1068 Temporary hack for Storybook.
export default Select;
